// Sidebar

function sidebarToggle() {
    $("body").toggleClass("sidebarCollapse");

    $(".sidebar").toggleClass("align-items-end");

    if (window.localStorage.getItem("sidebar")) {
        window.localStorage.removeItem("sidebar");
    } else {
        window.localStorage.setItem("sidebar", "collapsed");
    }
}

// Elements with this class get full height of the viewport
function giveFullHeight() {
	document.querySelectorAll('.full-height').forEach(function(el) {

		var potentialHeight = window.innerHeight - el.getBoundingClientRect().top;

		let fullHeightOffset;
		if (el.classList.contains('full-height-inner')) {
			fullHeightOffset = "3rem";
		} else {
			fullHeightOffset = "1rem";
		}

		let finalHeight = "calc(" + potentialHeight + "px - " + fullHeightOffset + ")";
        el.style.height = finalHeight;

        setTimeout(function () {
            doResize(el);
        }, 400);
    });
}

function doResize(el) {
    var tableInner = el.querySelector('.k-grid .k-grid-container .k-grid-content');
    if (tableInner != null) {
        let tableFooterHeight = 0;
        let pager = el.querySelector('.k-pager');
        let footer = el.querySelector('.k-grid-footer');

        if (pager != null) {
            tableFooterHeight += pager.offsetHeight;
        }

        if (footer != null) {
            tableFooterHeight += footer.offsetHeight;
        }

        var gridContentOffset = tableInner.getBoundingClientRect().top - el.getBoundingClientRect().top;

        var tableInnerFinalHeight = el.offsetHeight - (gridContentOffset + tableFooterHeight) + "px";
        tableInner.style.height = tableInnerFinalHeight;
    }
}

// onload
$(document).ready(function() {
    if (localStorage.getItem("sidebar")) {
		sidebarToggle();
		window.localStorage.setItem("sidebar", "collapsed");
	}

	$(".sidebarToggle, #closeSidebar").on("click", function() {
		sidebarToggle();
	});

	// Toggle na full screen (zmizí navigace)
	let fullScreen = false;
	function toggleFullScreen() {
		if (fullScreen == false) {
			fullScreen = !fullScreen;
			document.getElementsByTagName('body').classList.add('full-screen');
			setTimeout(function() {
				giveFullHeight();
			}, 500);
		} else {
			fullScreen = !fullScreen;
			document.getElementsByTagName('body').classList.remove('full-screen');
			setTimeout(function() {
				giveFullHeight();
			}, 500);
		}
	}

    var customfba = document.querySelector('.custom-fba_toggle');
    var customfbaLinks = document.querySelector('.custom-fba_links');
    if (customfba != null) {
        customfba.addEventListener('click', function () {
            this.classList.toggle('active');
            customfbaLinks.classList.toggle('active');
        });

        customfbaLinks.querySelector('li a').addEventListener('click', function() {
            customfba.classList.toggle('active');
            customfbaLinks.classList.toggle('active');
        });
        document.addEventListener('click', function(e) {
            var isClickInside = customfba.contains(e.target);
            if (!isClickInside) {
            customfba.classList.remove('active');
            customfbaLinks.classList.remove('active');
            }
        });
    }

    String.format = function () {
        var s = arguments[0];
        for (var i = 0; i < arguments.length - 1; i++) {
            var reg = new RegExp("\\{" + i + "\\}", "gm");
            s = s.replace(reg, arguments[i + 1]);
        }
        return s;
    }
}); // end onload

window.addEventListener('resize', giveFullHeight);

window.addEventListener("load", giveFullHeight);

// Local time zone offset
        function checkTimezoneCookie() {
            var timezone_cookie = 'tc_TimezoneOffset';
            if ($.cookie(timezone_cookie) == null) {
                $.cookie(timezone_cookie, new Date().getTimezoneOffset(), { expires: 1 });
            }
        }


$(function() {
			
	// Dropdown toggle fixes for sidebar
    var dropBtns = document.querySelectorAll('.sidebar .dropdown-toggle');
    var navItems = document.querySelectorAll('.sidebar ul.components > li');

    dropBtns.forEach(button => {
        button.addEventListener('click', function (e) {
            navItems.forEach(navItem => {
                navItem.classList.remove("active");
            })
            var parentLi = this.closest('li');
            if (parentLi) {
                parentLi.classList.toggle('active');
            }
        });
    });
});
